<div class="vc-modal__innerContainer sizeGuide__container">
  <button aria-label="close modal" class="vc-modal__closeBtn" [mat-dialog-close]>
    <span class="vc-modal__closeBtn__crossLeft"></span> <span class="vc-modal__closeBtn__crossRight"></span>
  </button>

  <vc-size-guide [size]="size" [standard]="standard" [sizeGuide]="sizeGuide"></vc-size-guide>
</div>
